"use client";
import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { buildBreadcrumbSchema, stringifyJsonLd } from "@/utils/breadcrumbSchema";

const BreadcrumbsSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      style={{ marginLeft: "7px" }}
    >
      <path
        d="M2 10L6 6L2 2"
        stroke="#005D82"
        strokeWidth="1.8"
        strokeLinecap="square"
      />
    </svg>
  );
};

const Breadcrumbs = ({ items }) => {
  const pathname = usePathname();

  if (!items || items.length === 0) return null;

  const schemaData = buildBreadcrumbSchema(items, pathname);

  return (
    <>
      <script
        id="BreadcrumbList"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: stringifyJsonLd(schemaData) }}
      />
      <div className="bg-blue-50" style={{ fontFamily: "saans-regular" }}>
        <div className="page-container py-[12px] md:py-[14px] flex flex-wrap items-center gap-x-[12px] gap-y-[8px] md:gap-[15px] mx-auto">
          <Link
            href="/"
            className="flex items-center text-base leading-tight tracking-normal text-[#005D82] whitespace-nowrap"
          >
            Home <BreadcrumbsSvg />
          </Link>

          {items.map((item, index) => {
            const label = item.label || "";
            const isLast = index === items.length - 1;

            if (isLast) {
              return (
                <span
                  key={index}
                  className="text-base leading-tight tracking-normal text-[#000000]"
                >
                  {label}
                </span>
              );
            }

            return (
              <React.Fragment key={index}>
                <Link
                  href={item.href || "#"}
                  className="flex items-center text-base leading-tight tracking-normal text-[#005D82] whitespace-nowrap"
                >
                  {label} <BreadcrumbsSvg />
                </Link>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Breadcrumbs;
